/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloatIconContent } from '../../models/float-icon-content';
import { FloatIconContentApiRespModel } from '../../models/float-icon-content-api-resp-model';

export interface ApiMasterHeaderFooterIconEditFloatIconPost$Params {
      body?: FloatIconContent
}

export function apiMasterHeaderFooterIconEditFloatIconPost(http: HttpClient, rootUrl: string, params?: ApiMasterHeaderFooterIconEditFloatIconPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FloatIconContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterHeaderFooterIconEditFloatIconPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloatIconContentApiRespModel>;
    })
  );
}

apiMasterHeaderFooterIconEditFloatIconPost.PATH = '/api/Master/HeaderFooterIcon/EditFloatIcon';
